import TargetGroupsList from './TargetGroupsList';
import TargetGroupItem from './TargetGroupItem';

export {
  TargetGroupsList,
  TargetGroupItem,
};



// WEBPACK FOOTER //
// ./src/components/TargetGroups/index.js